import React from "react";
import { Navigate } from "react-router-dom";
import { useStore } from "../_Store";

const FarmRequiredRoute = ({ children }) => {
  const {
    state: { userProfile },
  } = useStore();
  if (userProfile && userProfile.farms && userProfile.farms.length <=0) {
    return <Navigate to="/signup/completed" replace />;
  }
  return children;
};

export default FarmRequiredRoute;
